import GlassCamera from "@/assets/images/report/glass/camera.webp";
import GlassCard from "@/assets/images/report/glass/card.webp";
import GlassLightning from "@/assets/images/report/glass/lightning.webp";
import GlassPackage from "@/assets/images/report/glass/package.webp";
import GlassUsers from "@/assets/images/report/glass/users.webp";
import GlassWallet from "@/assets/images/report/glass/wallet.webp";
import { Box } from "@repo/components/src/ui/box";
import { HStack } from "@repo/components/src/ui/hstack";
import { formatMoneyFromFragment } from "@repo/components/src/utils/money";
import { formatNumber } from "@repo/components/src/utils/numbers";
import { CampaignAnalyticFragmentFragment } from "@repo/graphql/documents/campaign/fragment.generated";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import React from "react";
import KpiCard from "../shared/kpiCard";

dayjs.extend(duration);

type Props = {
  report: CampaignAnalyticFragmentFragment;
};

const KpiGrid = React.memo(({ report }: Props) => {
  const totalPiecesDelivered = report.totalPiecesDelivered;
  const totalPieces = report.totalPieces;
  const pendingPieces = Math.max(0, totalPieces - totalPiecesDelivered);

  const timeToDeliverSec = report.timeToDeliver;
  const tiempoVideo = timeToDeliverSec
    ? `${Math.round(dayjs.duration(timeToDeliverSec, "seconds").asDays() * 10) / 10}`
    : "—";

  const cards = [
    {
      image: GlassCamera,
      tone: "info" as const,
      label: "Videos aprobados",
      value: formatNumber(totalPiecesDelivered),
      unit: totalPieces ? `de ${totalPieces}` : "videos",
      sub: `${totalPiecesDelivered} aprobados, ${pendingPieces} pendientes`,
    },
    {
      image: GlassLightning,
      tone: "warning" as const,
      label: "Tiempo a video",
      value: tiempoVideo,
      unit: timeToDeliverSec ? "días" : undefined,
      sub: "Promedio desde envío de ODT a aprobación del video",
    },
    {
      image: GlassWallet,
      tone: "success" as const,
      label: "Inversión total",
      value: formatMoneyFromFragment(report.investment),
      sub: "Canje + efectivo",
    },
    {
      image: GlassCard,
      tone: "brand" as const,
      label: "Pago total",
      value: formatMoneyFromFragment(report.cashInvestment),
      sub: "Solo efectivo",
    },
    {
      image: GlassPackage,
      tone: "pink" as const,
      label: "Canje total",
      value: formatMoneyFromFragment(report.priceProducts),
      sub: "En productos",
    },
    {
      image: GlassUsers,
      tone: "info" as const,
      label: "Creadores UGC",
      value: formatNumber(report.creators),
      sub: "Total de creadores distintos",
    },
  ];

  return (
    <HStack className="flex-wrap -m-1.5">
      {cards.map((card) => (
        <Box key={card.label} className="w-1/3 p-1.5">
          <KpiCard {...card} />
        </Box>
      ))}
    </HStack>
  );
});

KpiGrid.displayName = "UgcKpiGrid";

export default KpiGrid;
